// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__150V2","title":"Card_title__2pmX2","year":"Card_year__f9qJx","Avatar":"Card_Avatar__1UFkj","user":"Card_user__Q3o0H"};